<!--
  Верстка адаптирована из шаблона:
  Файл: design-assets/themeforest_4DdWBZd0_education_online_courses_template_istudy (1)/istudy/courses-details.html
  Компонент: bd-course-details-content с заголовком "Description" (строки 732-739)
  Стили: design-assets/themeforest_4DdWBZd0_education_online_courses_template_istudy (1)/istudy/assets/css/main.css
  Классы: .bd-course-details-content-title (строка 18297), .description (строка 734)
-->
<template>
  <div class="course-description">
    <h2 class="description-title">{{ title }}</h2>
    <div v-if="description" class="description-text">
      <p v-for="(paragraph, index) in descriptionParagraphs" :key="index">
        {{ paragraph }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  title: string
  description?: string
}

const props = defineProps<Props>()

const descriptionParagraphs = computed(() => {
  if (!props.description) return []
  return props.description.split('\n').filter(p => p.trim())
})
</script>

<style scoped>
.course-description {
  margin-bottom: 40px;
}

.description-title {
  font-family: var(--font-inter);
  font-weight: 600;
  font-size: 60px;
  line-height: 1.2;
  color: #000000;
  margin: 0 0 32px 0;
}

.description-text {
  font-family: var(--font-inter);
  font-size: 16px;
  line-height: 1.7;
  color: #868D98;
}

.description-text p {
  margin: 0 0 16px 0;
}

.description-text p:last-child {
  margin-bottom: 0;
}

@media (max-width: 991px) {
  .description-title {
    margin-top: 50px;
    font-size: 28px;
  }

  .description-text {
    font-size: 15px;
  }
}

@media (max-width: 575px) {
  .description-title {
    margin-top: 40px;
    font-size: 24px;
  }

  .description-text {
    font-size: 14px;
  }
}
</style>
